module.exports = __webpack_public_path__ + "media/images/payments/solo-dark-a87f067bd62baa8dfe0a0188eecd1239.svg";